import { SORT } from '../constans/constans';

function alphabetically(ascending, sortParam) {
  return function (a, b) {
    a = (a[sortParam] || '').toLowerCase();
    b = (b[sortParam] || '').toLowerCase();
    if (a === b) {
      return 0;
    }
    if (a === '') {
      return 1;
    }
    if (b === '') {
      return -1;
    }
    if (ascending) {
      return a > b ? -1 : 1;
    }
    return a > b ? 1 : -1;
  };
}
export const sortData = (data = [], sortParam, sortAscDesc) => data.sort(alphabetically(sortAscDesc === SORT.ASC, sortParam));
